<template>
    <!-- SundAir Signup ---------------------------------------------------- -->
    <div id="agency-login" class="travelo-login-box sdr-box">
        <div class="seperator"><label>Hello Agency</label></div>
        <br />
        <form @submit.prevent="onSubmit">
            <div class="form-group">
                <input type="text" class="input-text full-width" placeholder="agency login" v-model="agency_login">
            </div>
            <div class="form-group">
                <input type="password" class="input-text full-width" placeholder="agency password" v-model="agency_password">
            </div>
            <br /><br />

            <button class="btn-medium uppercase full-width"><i class="soap-icon-trunk-1"></i>&nbsp;&nbsp;Login with Agency</button>
        </form>
        <div class="seperator"></div>
        <p>Don't have an account?&nbsp;&nbsp;<a class="goto-signup soap-popupbox">+49 30 53676791</a></p>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';

    import md5 from 'js-md5';


    export default {

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                language: {
                    en: 'Language',
                    de: 'Sprache',
                },
                // >>> ------------------------------------
                agency_login: '',
                agency_password: '',
                // >>> ------------------------------------
                lang: 'de'
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'get_Flag_Auth_UserLoggedIn', // is user logged in?
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_setCurrentLocale',
                'actn_call_GetAgency', // call:
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSubmit()
            *
            * Desc:
            * Note: Encrypt here (md5).
            *
            */
            onSubmit: function(submitEvent) {

                let me = this;


                me.$toc('>>> shared/header/AgencyLogin.vue >>> onSubmit');
                // >>> Guard ------------------------------
                if (this.get_Flag_Auth_UserLoggedIn === true) {
                    me.$toasted.global.sdr_app_error({
                        message : 'Login not possible. User is logged in.'
                    });
                    return;
                }


                // >>> Login ------------------------------
                if (this.agency_login !== '' && this.agency_password !== '') {
                    this.actn_call_GetAgency({ username: this.agency_login, password: md5(this.agency_password) });
                }

            }, // eo function onSubmit()

        }, // eo methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/shared/header/AgencyLogin.vue